const [{ ShadowElement }, connectSignalMixin] = await Promise.all([
	importMod("shadow-mixin"),
	importDefault("connect-signal-mixin"),
]);

export default class VariantCardCarousel extends connectSignalMixin(
	ShadowElement
) {
	connectedCallback() {
		super.connectedCallback();
		const nextBtn = this.shadow.getElementById("next");
		const prevBtn = this.shadow.getElementById("prev");
		const carousel = this.shadow.getElementById("carousel");

		if (
			!(nextBtn instanceof HTMLButtonElement) ||
			!(prevBtn instanceof HTMLButtonElement) ||
			!carousel
		) {
			return console.error("Missing required elements");
		}

		/** @param {Event} e */
		const handleNav = (e) => {
			let left = carousel.clientWidth;
			if (e.currentTarget === prevBtn) {
				left *= -1;
			}
			carousel.scrollBy({
				left,
				behavior: "smooth",
			});
		};

		/**
		 * @param {Element} target
		 * @param {boolean} isIntersecting
		 */
		const handleIntersection = (target, isIntersecting) => {
			if (target === carousel.children[0]) {
				prevBtn.disabled = isIntersecting || carousel.scrollLeft < 10;
			} else if (
				target === carousel.children[1] &&
				getComputedStyle(carousel.children[0]).display === "none"
			) {
				prevBtn.disabled = isIntersecting || carousel.scrollLeft < 10;
			}

			if (target === carousel.children[carousel.children.length - 1]) {
				nextBtn.disabled =
					isIntersecting ||
					carousel.scrollWidth - carousel.clientWidth - carousel.scrollLeft <
						10;
			}
		};

		const observer = new IntersectionObserver(
			(entries) => {
				for (const { target, isIntersecting } of entries) {
					handleIntersection(target, isIntersecting);
				}
			},
			{ root: carousel, threshold: 0.9 }
		);

		requestAnimationFrame(() => {
			const observeChildren = [
				carousel.children[0],
				carousel.children[1],
				carousel.children[carousel.children.length - 1],
			];
			for (const card of observeChildren) {
				observer.observe(card);
				if (card instanceof HTMLElement) {
					const offset =
						card.offsetLeft - carousel.offsetLeft - carousel.scrollLeft;
					handleIntersection(
						card,
						offset > 0 && offset + card.clientWidth < carousel.clientWidth
					);
				}
			}
		});
		const listenerOptions = { signal: this.connectedSignal };
		nextBtn.addEventListener("click", handleNav, listenerOptions);
		prevBtn.addEventListener("click", handleNav, listenerOptions);

		this.connectedSignal.addEventListener(
			"abort",
			() => observer.disconnect(),
			{ once: true }
		);
	}
}

customElements.define("variant-card-carousel", VariantCardCarousel);
